// extracted by mini-css-extract-plugin
export default {"chat-window":"NotificationWindow_chat-window__iRQEP"};